import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { useState } from "react";

import type { AnalysisPurchase } from "../../model/Analysis";
import { PurchaseLegend } from "./PurchaseLegend";
import { PurchaseTimeline } from "./PurchaseTimeline";

const SHOW = msg({
  id: "analysis.buy.show_all",
  message: "All purchases by time ({count})",
});
const HIDE = msg({ id: "analysis.buy.hide_all", message: "Hide purchases" });

type AllPurchasesProps = {
  purchases: readonly AnalysisPurchase[];
  heroId: number;
};

// Все покупки по фазам — по кнопке: главное в «Закупе» — ключевые предметы, лента
// из двадцати иконок нужна, когда хочется разобрать сборку целиком.
export const AllPurchases = ({ purchases, heroId }: AllPurchasesProps) => {
  const { _ } = useLingui();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => {
          setOpen(!open);
        }}
        className="min-h-11 self-start rounded-lg border border-border-strong px-4 text-sm text-accent transition-colors hover:border-accent/60 focus-visible:ring-2 focus-visible:ring-accent/60 focus-visible:outline-none"
      >
        {open ? _(HIDE) : _({ ...SHOW, values: { count: purchases.length } })}
      </button>
      {open && (
        <div className="flex flex-col gap-4">
          <PurchaseLegend />
          <PurchaseTimeline purchases={purchases} heroId={heroId} />
        </div>
      )}
    </>
  );
};
